'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import { forwardRef } from 'react';

/**
 * PaginationList component, use within a Pagination.
 *
 * @example
 * <Pagination>
 *   <PaginationList>
 *     <PaginationItem>
 *       <PaginationButton aria-label='Forrige side'>Forrige</PaginationButton>
 *     </PaginationItem>
 *   </PaginationList>
 * </Pagination>
 */
const PaginationList = forwardRef(function PaginationList({ asChild, ...rest }, ref) {
    const Component = asChild ? Slot : 'ul';
    return jsx(Component, { ref: ref, ...rest });
});

export { PaginationList };
